import { RouteRecordRaw } from 'vue-router';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { VIEW_MODE } from '@/common/define/common.define';
import { requireDomainTargetOrTutorial } from '@/common/router/authGuard';

const PREFIX_INFRASTRUCTURE = 'infrastructure_';

const infrastructureMenu: RouteRecordRaw[] = [
  {
    path: '/infrastructure/',
    name: `${PREFIX_INFRASTRUCTURE}Infrastructure`,
    component: BaseViewport,
    beforeEnter: [
      requireAuth,
      () => requireDomainTargetOrTutorial('infrastructure'),
      setDayjsTimezone,
    ],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_INFRASTRUCTURE,
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'host',
        name: `${PREFIX_INFRASTRUCTURE}Host`,
        component: () => import('@/infrastructure/views/hostView/HostView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_INFRASTRUCTURE_HOST,
        },
      },
      {
        path: 'container',
        name: `${PREFIX_INFRASTRUCTURE}Container`,
        component: () => import('@/infrastructure/views/containerView/ContainerView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_INFRASTRUCTURE_CONTAINER,
        },
      },
      {
        path: 'networkDevice',
        name: `${PREFIX_INFRASTRUCTURE}Network Device`,
        component: () => import('@/infrastructure/views/networkDeviceView/NetworkDeviceView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_INFRASTRUCTURE_NETWORK_DEVICE,
          invisibleViewMode: [VIEW_MODE.MAXGAUGE],
        },
      },
      {
        path: 'npm',
        name: `${PREFIX_INFRASTRUCTURE}Network Performance Monitoring`,
        component: () => import('@/infrastructure/views/npm/NetworkPerformanceMonitoring.vue'),
        meta: {
          rolePermission:
            ROLE_PERMISSION_KEY.MONITORING.MONITORING_INFRASTRUCTURE_NETWORK_PERFORMANCE_MONITORING,
          invisibleViewMode: [VIEW_MODE.MAXGAUGE],
        },
      },
      // 기존 Tool 메뉴 경로 redirect (Tool 메뉴가 /tool/로 이동)
      {
        path: 'tool',
        name: `${PREFIX_INFRASTRUCTURE}Tool Redirect`,
        redirect: () => ({ path: '/tool/script-manager' }),
        meta: {
          invisibleViewMode: [VIEW_MODE.EXEMONE, VIEW_MODE.MAXGAUGE, VIEW_MODE.INTERMAX],
        },
      },
      {
        path: 'tool/script-manager',
        name: `${PREFIX_INFRASTRUCTURE}Script Manager Redirect`,
        redirect: () => ({ path: '/tool/script-manager' }),
        meta: {
          invisibleViewMode: [VIEW_MODE.EXEMONE, VIEW_MODE.MAXGAUGE, VIEW_MODE.INTERMAX],
        },
      },
      {
        path: 'tool/script-manager-history',
        name: `${PREFIX_INFRASTRUCTURE}Script Manager History Redirect`,
        redirect: () => ({ path: '/tool/script-manager-history' }),
        meta: {
          invisibleViewMode: [VIEW_MODE.EXEMONE, VIEW_MODE.MAXGAUGE, VIEW_MODE.INTERMAX],
        },
      },
    ],
  },
];

const getInfrastructureNaviMenu = () => {
  const filteredInfrastructureMenu = extractAccessibleRoutes(infrastructureMenu);

  return [...filteredInfrastructureMenu];
};

export { infrastructureMenu, getInfrastructureNaviMenu };
